import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import AccountLayoutHeader from 'components/layouts/AccountLayoutHeader/AccountLayoutHeader';
import ProductSnapshotCard from 'components/layouts/Snapshot/ProductSnapshotCard';
import AccountsDataProvider from 'components/shared/DataProviders/AccountsDataProvider';
import { openBrokerageAuthTab } from 'services/ExternalAuthorizationURLBuilder';
import { EXIT_MODAL_VIEW_COUNT, isBrokerage, isCollegeSavings, isMutualFund } from 'services/Products';
import {
  isBrkInterceptMsgEnabled,
  isBrokerageAccountViewMessageEnabled
} from 'services/FeatureFlags';
import {
  hasSelfManagedAccounts,
  isBrokerageOwner
} from 'state/view/ViewSelectors';
import Store from 'state/Store';
import { filterAccountsGridAccountType } from 'state/account/AccountsGridFilteringActions';
import {
  getMutualFundPerformanceData,
  getCollegeSavingPlansData
} from 'state/performance/ProductPerformanceSelectors';
import InterceptMessageModal from 'components/shared/Modal/InterceptMessageModal';

const ProductSnapshotCardWithData = AccountsDataProvider(ProductSnapshotCard);

const SelfManagedSnapshot = ({
  hasSelfManagedAccounts,
  mutualFundData,
  collegeSavingPlansData,
  isBrokerageOwner
}) => {
  const [hasResponsebrkIntercept, setHasResponsebrkIntercept] = useState(true);
  const selectMutualFundAccounts = () => {
    Store.dispatch(filterAccountsGridAccountType('mutualFund'));
  };
  const mutualFundsFooter = (
    <Link
      to={{
        pathname: '/accounts',
        search: '?accountType=mutualFund'
      }}
      onClick={selectMutualFundAccounts}
      className="card-action-link">
      View Mutual Fund Details
    </Link>
  );

  const selectBrokerageAccounts = () => {
    Store.dispatch(filterAccountsGridAccountType('brokerage'));
  };
  const brokerageClickHandler = () => {
    openBrokerageAuthTab(undefined, 'ACCOUNTSNAPSHOT');
  };

  const handleModalOpen = () => {
    const modal = document.getElementById('account-selection-modal');
    const openedCount = Number(localStorage.getItem(EXIT_MODAL_VIEW_COUNT)) || 0;
    if (openedCount >= 3 || !hasResponsebrkIntercept) {
      brokerageClickHandler();
    } else {
      const newOpenCount = openedCount + 1;
      localStorage.setItem(EXIT_MODAL_VIEW_COUNT, newOpenCount);
      if (modal !== null) {
        modal.show();
      }
    }
  };
  const brokerageFooter = (
    <Fragment>
      <Link
        to={{
          pathname: '/accounts',
          search: '?accountType=brokerage'
        }}
        onClick={selectBrokerageAccounts}
        className="card-action-link">
        View Brokerage Details
      </Link>
      {isBrokerageOwner &&
        isBrokerageAccountViewMessageEnabled() && (
          <a
            target="_blank"
            rel="noreferrer noopener"
            className="card-action-link"
            onClick={
              isBrkInterceptMsgEnabled()
                ? handleModalOpen
                : brokerageClickHandler
            }>
            Visit Brokerage Platform
          </a>
        )}
    </Fragment>
  );

  const selectCollegeSavingsAccounts = () => {
    Store.dispatch(filterAccountsGridAccountType('collegeSavings'));
  };
  const collegeSavingsFooter = (
    <Link
      to={{
        pathname: '/accounts',
        search: '?accountType=collegeSavings'
      }}
      onClick={selectCollegeSavingsAccounts}
      className="card-action-link">
      View 529 Plan Details
    </Link>
  );

  return (
    <Fragment>
      {hasSelfManagedAccounts && (
        <div className="self-managed-snapshot">
          <AccountLayoutHeader
            text="Self-Managed"
            link="/accounts"
            detailText="Self-Managed Details"
            hideDetailLink
            isSubheader
          />

          <ProductSnapshotCardWithData
            title="Mutual Funds"
            prrData={mutualFundData}
            footer={mutualFundsFooter}
            filter={(account) => isMutualFund(account.productType)}
          />

          <ProductSnapshotCardWithData
            title="Brokerage"
            footer={brokerageFooter}
            filter={(account) => isBrokerage(account.productType)}
            hasIntradayRefresh={true}
          />

          <InterceptMessageModal
            openBrokerageAuthTab={brokerageClickHandler}
            setHasResponsebrkIntercept={setHasResponsebrkIntercept}
          />

          <ProductSnapshotCardWithData
            title="529 College Savings Plans"
            footer={collegeSavingsFooter}
            prrData={collegeSavingPlansData}
            filter={(account) => isCollegeSavings(account.productType)}
          />
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  hasSelfManagedAccounts: hasSelfManagedAccounts(state),
  mutualFundData: getMutualFundPerformanceData(state),
  collegeSavingPlansData: getCollegeSavingPlansData(state),
  isBrokerageOwner: isBrokerageOwner(state)
});

export default connect(mapStateToProps)(SelfManagedSnapshot);
